import { createFileRoute } from '@tanstack/react-router';
import { TestCaseCatalog } from '@/features/qa/TestCaseCatalog';
import { validModule } from '@/features/qa/coverageModel';

/**
 * Catalogo dei flussi di collaudo (`test-cases`), riusato da tutte le campagne.
 *
 * `?module=` arriva dal cruscotto in vista generale e apre il catalogo gia' filtrato su una
 * sezione. Si valida contro il vocabolario dei moduli: un valore inventato nell'URL
 * filtrerebbe via tutto e lascerebbe una pagina vuota che sembra un guasto.
 */
export const Route = createFileRoute('/_app/test-cases')({
  validateSearch: (s: Record<string, unknown>): { module?: string } => ({ module: validModule(s.module) }),
  component: CatalogPage,
});

function CatalogPage() {
  const { module } = Route.useSearch();
  return <TestCaseCatalog initialModule={module ?? null} />;
}
